export function dateFormatter (time, format = '{y}-{m}-{d} {h}:{i}:{s}') {
  let date
  if (time instanceof Date) {
    date = time
  } else if (typeof time === 'number') {
    const timestamp = Number((time.toString() + '000').substr(0, 13))
    date = new Date(timestamp)
  } else if (typeof time === 'string') {
    date = new Date(time)
  } else {
    return null
  }

  if (date.toString() === 'Invalid Date') return null
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds()
  }
  const timeStr = format.replace(/{(y|m|d|h|i|s)+}/g, (result, key) => {
    let value = formatObj[key]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return timeStr
}
export function convertTableSort (data) {
  if (data && data['prop'] && data['order']) {
    return JSON.stringify([{ key: data['prop'], value: data['order'] === 'descending' ? 'DESC' : 'ASC' }])
  }
  return null
}
